// frontend/src/components/common/DailyMotivationSection.js
import React, { useState } from 'react';
import { useLandingTranslation } from '../../hooks/useLandingTranslation';

const DailyMotivationSection = ({ className = "" }) => {
  const { t } = useLandingTranslation('basic'); // Using basic translations for now
  
  // Daily inspiration video cycling state
  const previewVideos = ['daily-inspiration-1.mov', 'daily-inspiration-5.mov', 'daily-inspiration-10.mov'];
  const previewPosters = ['daily-inspiration-1-poster.png', 'daily-inspiration-5-poster.png', 'daily-inspiration-10-poster.png'];
  const previewLabels = ['Motivación Diaria', 'Inspiración Personal', 'Mensaje de Progreso'];
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
  
  const handleRefreshPreview = () => {
    setCurrentPreviewIndex((prev) => (prev + 1) % previewVideos.length);
  };

  return (
    <section className={`py-5 bg-primary text-white ${className}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div className="mb-4">
              <div className="mb-3">
                <span 
                  className="badge px-3 py-2 fw-bold"
                  style={{ 
                    backgroundColor: '#ffc107', 
                    color: '#212529', 
                    fontSize: '1rem',
                    borderRadius: '20px'
                  }}
                >
                  ¡BONUS DIARIO!
                </span>
              </div>
              <h3 className="fw-bold mb-3">
                Videos Diarios de Motivación con Profe Zac
              </h3>
              <p className="mb-4 opacity-90">
                Además de las lecciones, recibes videos motivacionales diarios que te inspirarán a seguir aprendiendo inglés cada día.
              </p>
            </div>

            {/* Single Video with Refresh */}
            <div className="row justify-content-center mb-4">
              <div className="col-md-6 col-lg-5">
                <div className="card bg-white text-dark shadow-lg">
                  <div 
                    className="position-relative"
                    style={{
                      aspectRatio: '1/1',
                      overflow: 'hidden',
                      backgroundColor: '#000'
                    }}
                  >
                    <video 
                      key={currentPreviewIndex}
                      src={`/images/${previewVideos[currentPreviewIndex]}`}
                      poster={`/images/${previewPosters[currentPreviewIndex]}`}
                      preload="metadata"
                      playsInline
                      onClick={(e) => {
                        if (e.target.paused) {
                          e.target.play();
                        } else {
                          e.target.pause();
                        }
                      }}
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'contain', 
                        objectPosition: 'center center', 
                        display: 'block', 
                        cursor: 'pointer' 
                      }}
                    >
                      Your browser does not support the video tag.
                    </video>
                  </div>
                  <div className="card-body p-3 d-flex justify-content-between align-items-center">
                    <small className="text-muted fw-medium">{previewLabels[currentPreviewIndex]}</small>
                    <div className="d-flex gap-2">
                      <button 
                        className="btn btn-primary btn-sm d-flex align-items-center"
                        onClick={(e) => {
                          e.preventDefault();
                          const video = e.target.closest('.card').querySelector('video');
                          if (video.paused) {
                            video.play();
                          } else {
                            video.pause();
                          }
                        }}
                        style={{ fontSize: '0.8rem' }}
                      >
                        <i className="fas fa-play me-1"></i>
                        Ver
                      </button>
                      <button 
                        className="btn btn-outline-primary btn-sm d-flex align-items-center"
                        onClick={handleRefreshPreview}
                        style={{ fontSize: '0.8rem' }}
                      >
                        <i className="fas fa-sync-alt me-1"></i>
                        Ver Otro
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white bg-opacity-10 rounded p-3">
              <div className="d-flex align-items-center justify-content-center">
                <i className="fas fa-calendar-day me-2 fs-5"></i>
                <span className="fw-medium">
                  {t('dailyInspiration.rotationText')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DailyMotivationSection;